import { graphql } from '../graphql/generated';

export const DOCTOR_AIS_EXPORT_TYPES_QUERY = graphql(`
  query DoctorAisExportTypes($id: ID!) {
    doctor(id: $id) {
      id
      aisExportTypes
    }
  }
`);
